import { call, put } from "redux-saga/effects";
import { fetchLeaderboard } from "../../../api";
import { profileActions } from "../../../actions/profile";

export function* fetchLeaderboardSaga({ payload: { gameId } }) {
  try {
    const { response } = yield call(fetchLeaderboard, gameId);
    if (response) {
      yield put(profileActions.fetchLeaderboardSuccess(response));
    }
  } catch (error) {
    yield put(profileActions.fetchLeaderboardFailure(error));
  }
} 